import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Mousse = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.64 82.96">
  <G fill={color}>
    <Path d="M55.24,57.4c3.21-1.71,5.39-5.08,5.39-8.97,0-5.61-4.55-10.16-10.16-10.16-.99,0-1.95.15-2.86.42-.99-8.56-8.26-15.21-17.09-15.21-8.19,0-15.03,5.73-16.77,13.39-.15,0-.29-.02-.44-.02-7.36,0-13.32,5.96-13.32,13.32s5.96,13.32,13.32,13.32c.96,0,1.9-.11,2.8-.3,1.04,4.86,5.35,8.5,10.52,8.5,4.55,0,8.43-2.83,10-6.81,1.01.49,2.14.77,3.34.77,1.03,0,2.01-.21,2.91-.57.73,3.52,3.84,6.16,7.57,6.16,4.27,0,7.74-3.46,7.74-7.74,0-2.47-1.17-4.67-2.97-6.09Z"/>
    <Path d="M45.49,20.95c0,3.51,2.85,6.36,6.36,6.36s6.36-2.85,6.36-6.36-2.85-6.36-6.36-6.36-6.36,2.85-6.36,6.36Z"/>
    <Path d="M44.88,6.5c1.76,0,3.18-1.42,3.18-3.18s-1.42-3.18-3.18-3.18-3.18,1.42-3.18,3.18,1.42,3.18,3.18,3.18Z"/>
    <Path d="M37.41,76.6c-1.76,0-3.18,1.42-3.18,3.18s1.42,3.18,3.18,3.18,3.18-1.42,3.18-3.18-1.42-3.18-3.18-3.18Z"/>
    <Path d="M11.55,18.01c2.44,0,4.55-1.37,5.62-3.38,1.2.74,2.61,1.17,4.12,1.17,4.36,0,7.9-3.54,7.9-7.9S25.65,0,21.28,0c-3.59,0-6.62,2.4-7.58,5.68-.68-.24-1.4-.38-2.16-.38-3.51,0-6.36,2.85-6.36,6.36s2.85,6.36,6.36,6.36Z"/>
  </G>
</Svg>
);
};

export default Mousse;
